import React from "react";
import { isEmpty } from "lodash";
import { Alert } from "reactstrap";

const deep = ["address", "attributes", "meta"];
const displayError = (errors, entrylabel) => (
  <React.Fragment key={entrylabel}>
    {Object.keys(errors).map((key, i) =>
      deep.includes(key) ? (
        displayError(errors[key], key)
      ) : (
          <span key={`val-${i}-${key}`}>- {errors[key]} </span>
        )
    )}
  </React.Fragment>
);
const ValidationSummary = ({ errors }) =>
  !isEmpty(errors) ? (
    <Alert color="warning">{"Compilare correttamente tutti i campi."}</Alert> //displayError(errors, "errors")
  ) : null;

export default ValidationSummary;
